import PropTypes from "prop-types";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import Restaurant from "./Restaurant.jsx";
import Paragraphs from "app/pages/.shared/Paragraphs.jsx";
import MoreDetails from "app/pages/.shared/MoreDetails.jsx";
import { boardShape } from "app/utils/propTypes";
import Board from "app/pages/FicheProduit/components/Board/Board";
import "./RestaurantSection.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { LessIcon, MoreIcon } from "app/icons/navigation";
import { ICON_SIZES } from "app/constants";

const RestaurantSection = ({
	headline,
	intro = [],
	restaurants = [],
	facilities = [],
	boards = [],
}) => {
	const restaurantNodes = restaurants.map(restaurant => {
		return (
			<div className="restaurant-section__item" key={restaurant.name}>
				<Restaurant {...restaurant} />
			</div>
		);
	});

	return (
		<div className="restaurant-section">
			{headline && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="restaurant-section__title"
					component="h2"
				>
					{headline}
				</Typography>
			)}

			{intro && intro.length > 0 && (
				<div className="restaurant-section__intro">
					<Paragraphs paragraphs={intro} enableHTMLFormatting={true} />
				</div>
			)}

			{boards.map(board => {
				return (
					<div key={board.code} className="restaurant-section__item">
						<Board {...board} />
					</div>
				);
			})}

			{restaurantNodes}

			{facilities.length > 0 && (
				<div className="restaurant-section__details">
					<MoreDetails
						expandedIcon={<LessIcon size={ICON_SIZES.XS} />}
						collapsedIcon={<MoreIcon size={ICON_SIZES.XS} />}
						expandedLabel={<FormattedMessage id="product.page.less.details" />}
						collapsedLabel={<FormattedMessage id="product.page.more.details" />}
					>
						<Paragraphs paragraphs={facilities} enableHTMLFormatting />
					</MoreDetails>
				</div>
			)}
		</div>
	);
};

RestaurantSection.propTypes = {
	headline: PropTypes.string,
	intro: PropTypes.arrayOf(PropTypes.string),
	restaurants: PropTypes.array,
	facilities: PropTypes.arrayOf(PropTypes.string),
	boards: PropTypes.arrayOf(boardShape),
};

export default memo(RestaurantSection);
